import Icon from '../components/Icon.vue'

Icon.register({
  'i-cursor': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M256 52V12.1C256 5.5 250.7 0.1 244.2 0.1 211.6-0.3 166.5 0 128 38 90.3 0.7 47-0.1 11.9 0.1 5.3 0.2 0 5.5 0 12.1V51.8C0 58.4 5.5 63.8 12.1 63.8 38.1 63.4 96 67.2 96 112.2V224H60C53.4 224 48 229.4 48 236V276C48 282.6 53.4 288 60 288H96V400C96 444.9 39.9 448 12.1 448 5.4 447.9 0 453.3 0 460V499.9C0 506.5 5.3 511.9 11.8 511.9 44.4 512.3 89.5 512 128 474 165.7 511.3 209 512.1 244.1 511.9 250.7 511.8 256 506.5 256 499.9V460.2C256 453.6 250.5 448.2 243.9 448.2 217.9 448.6 160 444.9 160 400V288H196C202.6 288 208 282.6 208 276V236C208 229.4 202.6 224 196 224H160V112.2C160 67.3 216.1 64 243.9 64 250.6 64.1 256 58.7 256 52z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/i-cursor.js
// module id = JDk9
// module chunks = 144